import { render, staticRenderFns } from "./EditBms.vue?vue&type=template&id=5429b518&"
import script from "./EditBms.vue?vue&type=script&lang=js&"
export * from "./EditBms.vue?vue&type=script&lang=js&"
import style0 from "./EditBms.vue?vue&type=style&index=0&id=5429b518&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports